import { render, staticRenderFns } from "./WechatVideo.vue?vue&type=template&id=46133a31&scoped=true&"
import script from "./WechatVideo.vue?vue&type=script&lang=js&"
export * from "./WechatVideo.vue?vue&type=script&lang=js&"
import style0 from "./WechatVideo.vue?vue&type=style&index=0&id=46133a31&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46133a31",
  null
  
)

export default component.exports